import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AlertService } from "../_services";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";
import { EncryptionService } from "../_services/encryption.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { TestimonialsService } from "../_services/testimonials.service";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class Testimonials {
  id: number;
  name: string;
  designation: string;
  company_name: string;
  message: string;
  image: string;
  status: string;
}

@Component({
  selector: "app-testimonials",
  templateUrl: "./testimonials.component.html",
  styleUrls: [],
})
export class TestimonialsComponent implements OnInit {
  @Input() allowMultiple: boolean;
  isEditMode: boolean = false;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  testimonialsList: Testimonials[] = [];
  testimonialsTotal: any;
  isSubmitted = false;
  fileList: any;
  croppedImage: any = "";
  @Input() fileType: string = ".jpg , .jpeg, .png , .bmp";
  DisplayedText: string = "";
  @Input() required: boolean;
  start: number = 0;
  pageLength: number = 10;
  isUpdateMode: boolean = false;
  imageError: any;

  getTestimonials = {
    id: "",
    name: "",
    designation: "",
    company_name: "",
    message: "",
    image: "",
    status: "",
  };

  closeResult: string;
  myString: any;
  myArray: any;
  verticalArr = [];

  constructor(
    public router: Router,
    private dataService: TestimonialsService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private sanitizer: DomSanitizer
  ) {}

  testimonials = {
    id: "",
    name: "",
    designation: "",
    company_name: "",
    message: "",
    image: "",
    status: "",
  };

  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;
  isEndDateInvalid: boolean = false;

  ngOnInit() {
    window.scroll(0, 0);
    this.getTestimonialsListing();
    this.loadHide();
  }

  getTestimonialsListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      order: [[5, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/get-testimonial",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters))
              ),
            },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            this.testimonialsList = resp.data.map((item: any) => ({
              ...item,
              service_desc: this.truncate(item.service_desc, 100),
            }));

            this.testimonialsTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "name" },
        { data: "designation" },
        { data: "company_name" },
        { data: "message" },
        { data: "status" },
      ],
    };
  }

  truncate(value: any, limit: any) {
    if (!value) return "";
    if (value.length > limit) {
      return value.substring(0, limit) + "...";
    }
    return value;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  open(content) {
    this.croppedImage = "";
    this.isSubmitted = false;
    this.DisplayedText = "";
    if (this.getTestimonials.id != null) {
      this.getTestimonials.id = "";
    }

    this.testimonials.id = "";
    this.testimonials.name = "";
    this.testimonials.company_name = "";
    this.testimonials.message = "";
    this.testimonials.designation = "";
    this.testimonials.status = "Y";

    this.modalTitle = "Add Testimonials";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  save(val, f) {
    this.isSubmitted = true;
    this.isEditMode = !!val.id;
    this.imageError = "";

    if (!this.isEditMode && !this.fileList) {
      this.imageError = "Image is required";
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (f.form.valid) {
      this.insertAction(val, f);
    } else {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  edit(id, content) {
    this.isEndDateInvalid = false;
    this.isEditMode = true;
    this.fileList = "";
    this.loadShow();
    const data = {
      id: id,
    };
    this.dataService.editTestimonials(data).subscribe((res) => {
      this.getTestimonials = res["data"];
      this.croppedImage = this.getTestimonials.image;

      this.testimonials = {
        id: this.getTestimonials.id,
        name: this.getTestimonials.name,
        company_name: this.getTestimonials.company_name,
        message: this.getTestimonials.message,
        designation: this.getTestimonials.designation,
        status: this.getTestimonials.status,
        image: this.getTestimonials.image,
      };
      this.loadHide();
      this.modalTitle = "Edit Testimonials";
      this.modalReference = this.modalService.open(content, {
        backdrop: "static",
        keyboard: false,
      });
    });
  }

  onFileChange(event: any) {
    this.fileList = event.target.files;
    this.DisplayedText = this.fileList[0].name;

    let hasFile = this.fileList && this.fileList.length > 0;

    if (hasFile) {
      var extension = this.fileList[0].name
        .substring(this.fileList[0].name.lastIndexOf("."))
        .toLowerCase();

      var validFileTypes = [".jpg", ".jpeg", ".png", ".bmp"];

      if (!validFileTypes.includes(extension)) {
        this.imageError =
          "Please select a valid file type. The supported file types are .jpg, .jpeg, .png, .bmp";

        this.fileList = null;
        this.DisplayedText = "";
        this.croppedImage = "";
        this.testimonials.image = "";
        return false;
      }

      if (this.fileList[0].size > 5000000) {
        this.imageError = "Image size should not be more than 5 MB";
        this.fileList = null;
        this.DisplayedText = "";
        this.croppedImage = "";
        this.testimonials.image = "";
        return false;
      }

      this.imageError = "";
      const reader = new FileReader();
      reader.readAsDataURL(this.fileList[0]);
      reader.onload = () => {
        this.croppedImage = reader.result as string;
        this.testimonials.image = this.croppedImage;
      };

      let multipleFile = this.fileList.length > 1;
      if (!multipleFile) {
        let file: File = this.fileList[0];
      }
    }
    return false;
  }

  insertAction(val, f) {
    let formData: FormData = new FormData();

    formData.append("name", this.testimonials.name);
    formData.append("designation", this.testimonials.designation);
    formData.append("company_name", this.testimonials.company_name);
    formData.append("message", this.testimonials.message);
    formData.append("status", this.testimonials.status);

    if (val.id === "") {
      this.loadShow();
      if (this.fileList) {
        formData.append("image", this.croppedImage);
      }

      this.dataService.save(formData).subscribe(
        (data) => {
          this.loadHide();
          if (data["status"] === 200) {
            this.alertService.success(
              "Testimonials created successfully",
              true
            );

            const table = $("#testimonialTable").DataTable();
            table.ajax.reload(null, false);

            this.modalReference.close();
          } else if (data["status"] === 422) {
            if (data["mesg"] && data["mesg"]["image"]) {
              this.alertService.error(data.mesg.image);
              const modalElement = document.querySelector(".modal");
              if (modalElement) {
                modalElement.scrollTo({ top: 0, behavior: "smooth" });
              }
            } else {
              this.alertService.error("Api Error");
              const modalElement = document.querySelector(".modal");
              if (modalElement) {
                modalElement.scrollTo({ top: 0, behavior: "smooth" });
              }
            }
          } else {
            this.alertService.error("error");
            const modalElement = document.querySelector(".modal");
            if (modalElement) {
              modalElement.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        },
        (error) => {
          this.loadHide();
          this.alertService.error(error);
        }
      );
    } else {
      this.loadShow();
      formData.append("id", val.id);
      if (this.fileList) {
        formData.append("image", this.croppedImage);
      }

      this.dataService.updateTestimonials(formData).subscribe(
        (data) => {
          this.loadHide();
          if (data["status"] === 200) {
            this.alertService.success(
              "Testimonials updated successfully",
              true
            );
            this.modalReference.close();
            const table = $("#testimonialTable").DataTable();
            table.ajax.reload(null, false);
          } else {
            this.alertService.error(data.msg);
            const modalElement = document.querySelector(".modal");
            if (modalElement) {
              modalElement.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        },
        (error) => {
          this.loadHide();
          this.alertService.error(error);
        }
      );
    }
  }

  getRowNumber(index: number): number {
    return this.start + index + 1;
  }

  statusChange(item) {
    this.loadShow();
    const data = {
      id: item.id,
    };
    this.dataService
      .deleteTestimonials(data)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Testimonials deleted successfully",
              true
            );
            item.status = item.status === "Y" ? "N" : "Y";
            this.loadHide();
          } else {
            this.alertService.error("Testimonials error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
  }

  removePort(url) {
    const parsedUrl = new URL(url);
    parsedUrl.port = "";
    return parsedUrl.toString();
  }

  delete(item) {
    const confirmed = confirm(
      "Are you sure you want to delete this testimonial?"
    );

    if (!confirmed) {
      return;
    }

    const data = {
      id: item.id,
      type: "delete",
    };

    this.dataService
      .deleteTestimonials(data)
      .pipe()
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            this.alertService.success(
              "Testimonials deleted successfully",
              true
            );
            // item.status = item.status === "Y" ? "N" : "Y"; // Uncomment if needed
            const table = $("#testimonialTable").DataTable();
            table.ajax.reload(null, false); // Refresh the table after deletion
          } else {
            this.alertService.error("Error deleting testimonial");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
